import(/* webpackMode: "eager", webpackExports: ["ClientPage"] */ "/vercel/path0/src/app/(pages)/(case-studies)/sora/client.tsx");
